import { cleanUpRound } from './numbers'

/**
 * @param {DrugUnit[]} args
 * @returns {DrugUnit}
 */
const determineTargetUnit = (...args) => {
  if (args.includes('g')) return 'g'
  if (args.includes('mg')) return 'mg'
  return 'mcg'
}

const unitMultiple = {
  g: 2,
  mg: 1,
  mcg: 0,
}

/**
 * @param {number} value
 * @param {DrugUnit} currentUnit
 * @param {DrugUnit} targetUnit
 * @returns {number}
 */
export const toTargetUnit = (value, currentUnit, targetUnit) => {
  const currentUnitMultiple = unitMultiple[currentUnit]
  const targetUnitMultiple = unitMultiple[targetUnit]
  const diff = currentUnitMultiple - targetUnitMultiple
  if (!diff) {
    return value
  }
  const multiple = Math.pow(1000, Math.abs(diff))
  return cleanUpRound(diff < 0 ? value / multiple : value * multiple)
}

/**
 * @param {any} amount1
 * @param {DrugUnit} firstUnit
 * @param {any} amount2
 * @param {DrugUnit} secondUnit
 * @param {DrugUnit} [targetUnit]
 * @returns {{
 *   amount: number
 *   unit: DrugUnit
 * }}
 */
export const addDiffUnits = (
  amount1,
  firstUnit,
  amount2,
  secondUnit,
  targetUnit
) => {
  const finalUnit = targetUnit || determineTargetUnit(firstUnit, secondUnit)
  return {
    amount: cleanUpRound(
      toTargetUnit(amount1, firstUnit, finalUnit) +
        toTargetUnit(amount2, secondUnit, finalUnit)
    ),
    unit: finalUnit,
  }
}
